import { UserComplaint } from '../../../graphql/API';

export const COMPLAINT_TYPES = ['Update Instagram', 'Update profile picture'];

export type ComplaintType = (typeof COMPLAINT_TYPES)[number];

export type OnClickComplaint = (data: UserComplaint) => void;

export type ColumnProps = { onClickComplaint: OnClickComplaint };
